"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _system = require("@mui/system");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../../elements/Heading/Heading"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _DataCallout = _interopRequireDefault(require("../../../components/DataCallout/DataCallout"));
var _HorizontalDivider = _interopRequireDefault(require("../../../elements/horizontal-divider/Horizontal-Divider"));
var _PageGrid = _interopRequireDefault(require("../../../layouts/Skeletons/PageGrid/PageGrid"));
var _excluded = ["srcPictureOne", "srcPictureTwo", "srcPictureThree", "altPictureOne", "altPictureTwo", "altPictureThree"],
  _excluded2 = ["problemVariant", "problemHeadingCopy", "problemSubheadingCopy", "resultHeadingCopy", "resultSubheadingCopy", "problemPictureOne", "problemPictureTwo", "problemPictureThree", "problemAltPictureOne", "problemAltPictureTwo", "problemAltPictureThree", "resultPictureOne", "dataHeadingCopy", "dataSubheadingCopy"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var ProblemImage = _styledComponents.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  @media (min-width: ", ") {\n\n  }\n\n  @media (min-width: ", ") {\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    gray: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledColumn = (0, _styledComponents.default)(_Grid.default)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  margin-bottom: 35px;\n"])));
var StyledBox = (0, _styledComponents.default)(_system.Box)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  /* padding-bottom: 32.5px;  */\n  /* padding-top: 32.5px; */\n  background-image: url(", ");\n  background-color: ", ";\n  \n  @media (min-width: ", ") {\n    /* padding-bottom: 75px;  */\n    /* padding-top: 75px; */\n  }\n"])), function (props) {
  return props.backgroundImageUrl;
}, function (props) {
  return props.heroBackgroundColor;
}, _bfBaseStyles.Breakpoints.m);
function ProblemThreeColumn(_ref3) {
  var srcPictureOne = _ref3.srcPictureOne,
    srcPictureTwo = _ref3.srcPictureTwo,
    srcPictureThree = _ref3.srcPictureThree,
    altPictureOne = _ref3.altPictureOne,
    altPictureTwo = _ref3.altPictureTwo,
    altPictureThree = _ref3.altPictureThree,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_ThreeColumnLayout.default, Object.assign({
    justifyContent: 'center'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(ProblemImage, {
    src: srcPictureOne,
    alt: altPictureOne
  })), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(ProblemImage, {
    src: srcPictureTwo,
    alt: altPictureTwo
  })), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(ProblemImage, {
    src: srcPictureThree,
    alt: altPictureThree
  })));
}
;
var ProblemStatement = function ProblemStatement(_ref4) {
  var problemVariant = _ref4.problemVariant,
    problemHeadingCopy = _ref4.problemHeadingCopy,
    problemSubheadingCopy = _ref4.problemSubheadingCopy,
    resultHeadingCopy = _ref4.resultHeadingCopy,
    resultSubheadingCopy = _ref4.resultSubheadingCopy,
    problemPictureOne = _ref4.problemPictureOne,
    problemPictureTwo = _ref4.problemPictureTwo,
    problemPictureThree = _ref4.problemPictureThree,
    problemAltPictureOne = _ref4.problemAltPictureOne,
    problemAltPictureTwo = _ref4.problemAltPictureTwo,
    problemAltPictureThree = _ref4.problemAltPictureThree,
    resultPictureOne = _ref4.resultPictureOne,
    dataHeadingCopy = _ref4.dataHeadingCopy,
    dataSubheadingCopy = _ref4.dataSubheadingCopy,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return _react.default.createElement(StyledBox, props, _react.default.createElement(_PageGrid.default, null, _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center",
    justifyContent: "center"
  }, props), _react.default.createElement(StyledColumn, {
    item: true,
    justifyContent: "center"
  }, _react.default.createElement(StyledSectionHeading, props, " ", problemHeadingCopy, " "), _react.default.createElement(StyledSectionSubheading, props, " ", problemSubheadingCopy, "  ")), _react.default.createElement(ProblemThreeColumn, Object.assign({
    srcPictureOne: problemPictureOne,
    srcPictureTwo: problemPictureTwo,
    srcPictureThree: problemPictureThree,
    altPictureOne: problemAltPictureOne,
    altPictureTwo: problemAltPictureTwo,
    altPictureThree: problemAltPictureThree,
    variant: problemVariant
  }, props)), _react.default.createElement(_HorizontalDivider.default, null), _react.default.createElement(StyledColumn, {
    item: true,
    justifyContent: "center"
  }, _react.default.createElement(StyledSectionHeading, props, " ", resultHeadingCopy, " "), _react.default.createElement(StyledSectionSubheading, props, " ", resultSubheadingCopy, "  "), _react.default.createElement(_DataCallout.default, {
    dataPoint: dataHeadingCopy,
    dataDescription: dataSubheadingCopy
  })))));
};
var _default = ProblemStatement;
exports.default = _default;